import { render, staticRenderFns } from "./EcpModal.vue?vue&type=template&id=1940dd86&"
import script from "./EcpModal.vue?vue&type=script&lang=js&"
export * from "./EcpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports